// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"z3-z","dimensionLabel":"A3-z","styleChooserControlWrapper":"B3-z","styleChooserControl":"C3-z","disabled":"D3-z","giftCard":"E3-z","styleChooserText":"F3-z"};